/**
 * Client-side preflight affordability for generation/training actions.
 *
 * Soft-limit workspaces are never gated. Hard-limit workspaces are gated only
 * when available balance is known and strictly below the action price.
 * Stale or unknown entitlement/price must not disable the action — execution
 * still enforces authorization server-side.
 */
export type PreflightEntitlement = {
  availableBalance: number | null;
  isSoftLimit: boolean;
  isStale: boolean;
} | null;

export const isPreflightGated = (args: {
  actionPrice: number | null | undefined;
  entitlement: PreflightEntitlement;
}): boolean => {
  const { actionPrice, entitlement } = args;

  if (entitlement == null) {
    return false;
  }
  if (entitlement.isSoftLimit) {
    return false;
  }
  if (entitlement.isStale) {
    return false;
  }
  if (actionPrice == null || Number.isNaN(actionPrice)) {
    return false;
  }
  if (entitlement.availableBalance == null) {
    return false;
  }

  return entitlement.availableBalance < actionPrice;
};
